var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contenedor-listado-infraestructura-desktop"}},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.listadoInfraestructura,"items-per-page":20},scopedSlots:_vm._u([{key:"item.vidaUtilEstimados",fn:function(ref){
var item = ref.item;
return [_vm._v("\n      "+_vm._s(_vm.getVidaUtilRestante(item))+"\n    ")]}},{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('opciones',{attrs:{"infraestructura":item}})]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }